import React from 'react'
import { Row, Col } from 'react-bootstrap'
import ExamPaperCard from './ExamPaperCard'
import ExamPaperFooter from './ExamPaperFooter'
import ExamPaperTableView from './ExamPaperTableView'
import PdfReader from '../../../components/PdfReader'
import { getFileType } from '../../../utils/helper'

import { FaRegBookmark, FaBookmark } from 'react-icons/fa'

const Q_PLACEHOLDER = 'https://placehold.co/320x240?text=Question'
const MS_PLACEHOLDER = 'https://placehold.co/320x240?text=No+scheme'

function AllComponent({
  selectedPapers,
  setSelectedPapers,
  questions,
  allBookmarkedIds,
  handleBookmarkClick,
  handleQuestionClick,
  resultsLayout = 'single',
}) {
  const togglePaperSelection = (id, isSelected) => {
    setSelectedPapers((prev) =>
      isSelected ? [...prev, id] : prev.filter((paperId) => paperId !== id),
    )
  }

  if (resultsLayout === 'single') {
    return (
      <div className='filter-content filter-content--table'>
        <ExamPaperTableView
          questions={questions}
          allBookmarkedIds={allBookmarkedIds}
          handleBookmarkClick={handleBookmarkClick}
          handleQuestionClick={handleQuestionClick}
        />
      </div>
    )
  }

  return (
    <>
      <Row className='filter-content'>
        {questions.map((question, index) => {
          const isBookmarked = allBookmarkedIds.has(question._id)
          return (
            <Col key={question._id} xl={12} xxl={6} className='mb-4'>
              <div
              // onClick={() => handleQuestionClick(question)}
              >
                <ExamPaperCard
                  id={question._id}
                  title={`Q. ${question.question_number} ${question.part}`}
                  onCheckboxChange={(isSelected) =>
                    togglePaperSelection(question._id, isSelected)
                  }
                  isChecked={selectedPapers.includes(question._id)}
                  key={
                    question._id +
                    (isBookmarked ? '-bookmarked' : '-not-bookmarked')
                  }
                  bookMarkIconBtn={
                    isBookmarked ? <FaBookmark /> : <FaRegBookmark />
                  }
                  onBookmarkClick={(e) =>
                    handleBookmarkClick(e, question, isBookmarked)
                  }
                  onBodyClick={() => handleQuestionClick(question)}
                  bodyContent={
                    getFileType(question?.question_file) === 'pdf' ? (
                      <PdfReader
                        file={question.question_file}
                        showFullScreenButton={false}
                      />
                    ) : (
                      <img
                        src={question.question_file || Q_PLACEHOLDER}
                        alt={`Question ${question.question_number}`}
                        style={{
                          width: 'auto',
                          maxWidth: '100%',
                          height: 'auto',
                          objectFit: 'contain',
                          display: 'block',
                        }}
                        onError={(e) => {
                          e.target.onerror = null
                          e.target.src = Q_PLACEHOLDER
                        }}
                      />
                    )
                  }
                  footerContent={
                    <ExamPaperFooter
                      subject={question.topics[0]?.title}
                      paper={question.paper}
                      year={question.year}
                      markingSchemeContent={
                        getFileType(question?.ms_file) === 'pdf' ? (
                          <PdfReader
                            file={question.ms_file}
                            showFullScreenButton={false}
                          />
                        ) : (
                          <img
                            src={question.ms_file || MS_PLACEHOLDER}
                            alt={`Question ${question.question_number}`}
                            style={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                            }}
                            onError={(e) => {
                              e.target.onerror = null
                              e.target.src = MS_PLACEHOLDER
                            }}
                          />
                        )
                      }
                    />
                  }
                />
              </div>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default AllComponent
